import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from "@material-ui/core/styles";
import { usePages } from "../../pagesContext";
import { addRegisteredStepper } from "./stepperDescriptions";
import { usePageState } from "../../PageContext";
const useStepperXofYStyles = makeStyles((theme) => ({
    circle: {
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.main,
        boxSizing: "border-box",
        mozBoxSizing: "border-box",
        webkitBoxSizing: "border-box",
        textAlign: "center",
        width: 85,
        height: 85,
        margin: "0 auto"
    },
    stepperCircleInnerText: {
        fontWeight: "bold"
    },
    pageIndex: {
        fontSize: 32
    },
    pageCount: {
        fontSize: 20
    }
}));
addRegisteredStepper({
    name: "XofYStepper",
    displayName: "XofYStepper"
});
export const XofYStepper = (props) => {
    const pages = usePages();
    const { step } = usePageState();
    var count = -1;
    const displayIndexArr = pages.map(p => {
        if (p.displayInStepper) {
            count += 1;
            return count;
        }
        return -1;
    });
    const getDisplayNum = (step) => {
        if (step === 0 && displayIndexArr[step] === -1) {
            return -1;
        }
        return displayIndexArr[step] === -1
            ? getDisplayNum(step - 1)
            : displayIndexArr[step];
    };
    const activeStep = getDisplayNum(step);
    const xOfYClasses = useStepperXofYStyles();
    return activeStep > -1 ? (_jsx("div", { className: xOfYClasses.circle, children: _jsxs("p", { className: xOfYClasses.stepperCircleInnerText, children: [_jsx("span", { className: xOfYClasses.pageIndex, children: activeStep + 1 }), _jsxs("span", { className: xOfYClasses.pageCount, children: [" ", "/ ", displayIndexArr.filter(x => x >= 0).length] })] }) })) : null;
};
//# sourceMappingURL=XofYStepper.js.map